/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    leftBtn: "Précédent",
    rightBtn: "Suivant",
    todayResetBtn: "Aujourd'hui"
};